import { Props } from '@/pages/Profile/components/SectionHeading/types';
import Heading from '@/ui/components/Heading';

const SectionHeading = ({ text, visible = false }: Props) => {
  return <Heading className={`mb-2 ${visible ? '' : 'sr-only'}`} value={3} text={text} />;
};

export default SectionHeading;
